import { FC } from 'react';

import { Avatar } from 'react-activity-feed';

import { State } from '../../../types/feed';

import { UserIds } from '../../../types/feed';

import avatar from '../../../images/avatar.png';

import styles from './ProfileHeader.module.css';

export type Props = {
  state: State;
  profileImage?: string;
  name?: string;
  following?: number;
  followers?: number;
};

export const ProfileHeader: FC<Props> = ({ state }) => (
  <header className={styles.header}>
    <Avatar
      size={60}
      circle
      image={
        state?.[UserIds.Eric]?.client?.currentUser?.data?.profileImage || avatar
      }
    />
    <div className={styles.profile}>
      <p className={styles.name}>
        {state?.[UserIds.Eric]?.client?.currentUser?.data?.name}
      </p>
      <p className={styles.stats}>
        <span className={styles.stat}>
          <b>{state?.[UserIds.Eric]?.following || 0}</b> Following
        </span>
        <span className={styles.stat}>
          <b>{state?.[UserIds.Eric]?.followers || 0}</b> Followers
        </span>
      </p>
    </div>
  </header>
);
